var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.476,
    height: 20.131,
    viewBox: "0 0 17.476 20.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2620",
    "data-name": "Group 2620",
    transform: "translate(-654.113 -387.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "award-fill",
    transform: "translate(659.393 394.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    d: "M8.619,0,9.631.524l1.126.171.51,1.018.81.8-.185,1.124.186,1.124-.81.8-.51,1.018-1.126.171-1.012.524L7.608,6.749,6.482,6.578,5.972,5.56l-.81-.8.185-1.124L5.161,2.513l.81-.8L6.481.695,7.608.524Z",
    transform: "translate(-5.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    d: "M9,26.536v2.549l2.424-.606,2.424.606V26.536l-1.223.186-1.2.622-1.2-.622Z",
    transform: "translate(-7.966 -19.388)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "document-blank",
    d: "M23.963,7.5,17.846,2.466a.882.882,0,0,0-.611-.216H8.5A1.621,1.621,0,0,0,6.75,3.688V20.943A1.621,1.621,0,0,0,8.5,22.381h13.98a1.621,1.621,0,0,0,1.748-1.438V8a.605.605,0,0,0-.262-.5ZM17.235,3.975,22.128,8H17.235Zm5.243,16.967H8.5V3.688h6.99V8a1.621,1.621,0,0,0,1.748,1.438h5.243Z",
    transform: "translate(647.363 384.815)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.5380fa478b0af78c637b84b4042bde8a.svg";
export { ForwardRef as ReactComponent };